// Custom Tailwind font sizes. Shared by tailwind.config.js and src/utils/cn.js,
// which registers them with tailwind-merge so classes like `text-14` are not
// mistaken for text colors (and merged away against `text-white`).
module.exports = {
  xxxs: '.625rem',
  xxs: '.7rem',
  ms: '.825rem',
  s: '.9rem',
  l: '1.125rem',
  '1.5xl': '1.375rem',
  '4.5xl': '2.5rem',
  '4.75xl': '2.75rem',
  '4.9xl': '2.875rem',

  /// redesign config
  'primary-xs': '32px',
  'primary-md': '48px',
  'heading-1': '48px',
  'heading-2': '32px',
  'heading-3': '24px',
  'heading-3.5': '20px',
  'heading-4': '18px',
  10: '0.625rem',
  11: '0.688rem',
  12: '0.75rem',
  16: '1rem',

  /////////// REDESIGN OF BRAND PAGES V2 ///////////
  '2.5xl': '1.75rem',
  '3.5xl': '2rem',
  13: '13px',
  14: '14px',
  15: '0.9375rem',
  23: '23px',
  32: '32px',
  36: '36px',
  57: '3.5625rem',
  28: '28px',
  37: '37px',
  8: '8px',
  '1.9xl': '23px',

  //Typography approach
  'body-x-small': [
    '12px',
    {
      lineHeight: '16.8px',
      fontWeight: '400',
    },
  ],
  'body-small': [
    '14px',
    {
      lineHeight: '19.6px',
      fontWeight: '400',
    },
  ],
  'body-medium': [
    '16px',
    {
      lineHeight: '22.4px',
      fontWeight: '400',
    },
  ],
  'body-large': [
    '18px',
    {
      lineHeight: '25.2px',
      fontWeight: '400',
    },
  ],
  'display-x-small': [
    '16px',
    {
      lineHeight: '140%',
      fontWeight: '700',
    },
  ],
  'display-small': [
    '20px',
    {
      lineHeight: '120%',
      fontWeight: '700',
    },
  ],
  'display-medium': [
    '28px',
    {
      lineHeight: '120%',
      fontWeight: '700',
      letterSpacing: '-0.01em',
    },
  ],
  'display-large': [
    '36px',
    {
      lineHeight: '43.2px',
      fontWeight: '500',
      letterSpacing: '-0.01em',
    },
  ],
  'display-x-large': [
    '48px',
    {
      lineHeight: '57.6px',
      fontWeight: '500',
      letterSpacing: '-0.01em',
    },
  ],
  'display-2x-large': [
    '60px',
    {
      lineHeight: '72px',
      fontWeight: '500',
      letterSpacing: '-0.01em',
    },
  ],
  'display-3x-large': [
    '68px',
    {
      lineHeight: '81.6px',
      fontWeight: '500',
      letterSpacing: '-0.01em',
    },
  ],
  'heading-large': [
    '32px',
    {
      lineHeight: '41.6px',
      fontWeight: '700',
    },
  ],
  'heading-medium': [
    '24px',
    {
      lineHeight: '31.2px',
      fontWeight: '700',
    },
  ],
  'heading-small': [
    '18px',
    {
      lineHeight: '130%',
      fontWeight: '700',
    },
  ],
  'label-overline': [
    '14px',
    {
      lineHeight: '16.8px',
      fontWeight: '700',
      letterSpacing: '0.25em',
    },
  ],
  'label-small': [
    '14px',
    {
      lineHeight: '120%',
      fontWeight: '500',
    },
  ],
  'label-medium': [
    '16px',
    {
      lineHeight: '120%',
      fontWeight: '500',
    },
  ],
  'label-button-medium': [
    '18px',
    {
      lineHeight: '21.6px',
      fontWeight: '700',
      letterSpacing: '0.02em',
    },
  ],
}
